import { useContext, useMemo } from 'react';

//context
import { EditorContext } from '../../context/EditorContext';

// models
import { PushProviders } from '../../models/pushProvider.model';

// hooks
import usePushIntegrationsQuery from './usePushIntegrationsQuery';

interface UseGetCustomerPushIntegrationData {
    providerName?: PushProviders;
}

export default function useGetCustomerPushIntegration(): UseGetCustomerPushIntegrationData {
    const { isLoading, data } = usePushIntegrationsQuery();
    const {
        editorDetails: { formulaType },
    } = useContext(EditorContext);

    const providerName = useMemo<PushProviders | undefined>(() => {
        if (!isLoading && data) {
            return data?.find((item) => item.channels?.includes(formulaType!))
                ?.push_provider_name;
        }
    }, [data, formulaType, isLoading]);

    return { providerName };
}
